import { useEffect } from "react"
import { loadScript } from "../utils/loadScripts"
import Footer from "./Footer"
import Header from "./Header"

function Contact() {

    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
            await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>
            <div id="swup">
                <Header />
                {/* <!-- content --> */}
                <div className="mil-content">
                    <div id="swupMain" className="mil-main-transition">

                        {/* <!-- banner --> */}
                        <div className="mil-inner-banner mil-p-0-120">
                            <div className="mil-banner-content mil-center mil-up">
                                <div className="container">
                                    <ul className="mil-breadcrumbs mil-center mil-mb-60">
                                        <li><a href="/">Home / </a></li>
                                        <li><a href="/contact">Contact</a></li>
                                    </ul>
                                    <h1 className="mil-mb-60">Get in touch!</h1>
                                    <a href="#contact" className="mil-link mil-dark mil-arrow-place mil-down-arrow">
                                        <span>Send message</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* <!-- banner end --> */}

                        {/* <!-- map -->
                <!--<div className="mil-map-frame mil-up">
                    <div className="mil-map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1396.5769090312324!2d-73.6519672!3d45.5673453!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91f8abc30e0ff%3A0xfc6d9cbb49022e9c!2sManoir%20Saint-Joseph!5e0!3m2!1sen!2sua!4v1685485811069!5m2!1sen!2sua" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>--> */}
                        {/* <!-- map end -->

                <!-- contact form --> */}
                        <section id="contact">
                            <div className="container mil-p-60-90">
                                {/* <!-- <h3 className="mil-center mil-up mil-mb-120">Let's <span className="mil-thin">Talk</span></h3> --> */}
                                <form className="row align-items-center">
                                    <div className="col-lg-6 mil-up">
                                        <input type="text" placeholder="Name" />
                                    </div>
                                    <div className="col-lg-6 mil-up">
                                        <input type="email" placeholder="Email ID" />
                                    </div>
                                    <div className="col-lg-6 mil-up">
                                        <input type="tel" placeholder="Mobile Number ?" />
                                    </div>
                                    <div className="col-lg-6 mil-up">
                                        <input type="text" placeholder="City/Location" />
                                    </div>
                                    <div className="col-lg-12 mil-up">
                                        <textarea placeholder="Tell us as descriptive as possible"></textarea>
                                    </div>
                                    <div className="col-lg-8">
                                        <p className="mil-up mil-mb-30"><span className="mil-accent">*</span> We promise not to disclose your personal information to third parties.</p>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="mil-adaptive-right mil-up mil-mb-30">
                                            <button type="submit" className="mil-button mil-arrow-place">
                                                <span>Send message</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </section>
                        {/* <!-- contact form end --> */}

                        {/* Newsletter Section */}
                        <section
                                style={{
                                     backgroundColor: "#efefef",
                                     width: "100%",
                                     padding: "120px 0"
                                }}
                                >
                                    <div className="container mil-p-120-120">
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">

                                        <p className="mil-text-sm mil-center mil-up mil-mb-60">
                                            Looking to make your mark? We'll help you turn
                                            your project into a success story.
                                        </p>

                                        <h2 className="mil-center mil-up mil-mb-60">
                                            Stay up-to-date <span className="mil-thin">with the</span>
                                            <br />
                                            latest news by <span className="mil-thin">subscribing</span>
                                            <br />
                                            to our <span className="mil-thin">newsletter!</span>
                                        </h2>

                                        <div className="mil-center">
                                            <form className="mil-subscribe-form">
                                                <input
                                                    type="email"
                                                    placeholder="ENTER OUR EMAIL"
                                                />
                                                <button
                                                    type="submit"
                                                    className="mil-button mil-icon-button-sm"
                                                >
                                                     →
                                                </button>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
                {/* <!-- content --> */}
                <Footer />

            </div>

        </>
    )
}

export default Contact